(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function formatProductMoney(cents, currency) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AUD' }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function syncProductForm(section) {
    var select = section.querySelector('[data-ct-variant-select]');
    var option = select ? select.options[select.selectedIndex] : null;
    var submit = section.querySelector('[data-ct-product-submit]');
    var label = section.querySelector('[data-ct-product-submit-label]');
    var quantityInput = section.querySelector('[data-ct-quantity-input]');
    var note = section.querySelector('[data-ct-variant-note]');
    var priceMeta = section.querySelector('[data-ct-product-price-meta]');
    var price = section.querySelector('[data-ct-product-price]');
    var compare = section.querySelector('[data-ct-product-compare-price]');
    var variantInput = section.querySelector('[data-ct-variant-input]');
    var sellingPlanInput = section.querySelector('[data-ct-selling-plan-input]');
    var purchaseWrap = section.querySelector('[data-ct-purchase-type-wrap]');
    var onetimeRadio = section.querySelector('[data-ct-purchase-radio="onetime"]');
    var subscribeRadio = section.querySelector('[data-ct-purchase-radio="subscribe"]');
    var onetimeOption = section.querySelector('[data-ct-purchase-option="onetime"]');
    var subscribeOption = section.querySelector('[data-ct-purchase-option="subscribe"]');
    if (!option || !submit || !label) return;

    if (variantInput) variantInput.value = option.value;

    var hasSubscription = option.getAttribute('data-has-subscription') === 'true';

    if (purchaseWrap) {
      purchaseWrap.hidden = !hasSubscription;
      if (!hasSubscription && onetimeRadio && !onetimeRadio.checked) {
        onetimeRadio.checked = true;
      }
    }

    if (hasSubscription) {
      var subPriceEl = section.querySelector('[data-ct-subscribe-price]');
      var subCompareEl = section.querySelector('[data-ct-subscribe-compare]');
      var subPlanEl = section.querySelector('[data-ct-subscribe-plan-name]');
      var subDiscountEl = section.querySelector('[data-ct-subscribe-discount]');
      if (subPriceEl) subPriceEl.textContent = option.getAttribute('data-subscription-price') || '';
      if (subCompareEl) subCompareEl.textContent = option.getAttribute('data-subscription-compare') || '';
      if (subPlanEl) {
        var planName = option.getAttribute('data-plan-name');
        subPlanEl.textContent = planName ? '· ' + planName : '';
      }
      if (subDiscountEl) {
        var discountPercent = option.getAttribute('data-subscription-discount-percent');
        subDiscountEl.textContent = discountPercent && discountPercent !== '0' ? discountPercent + '% off' : '';
      }
    }

    var isSubscribe = !!(subscribeRadio && subscribeRadio.checked && hasSubscription);
    if (sellingPlanInput) sellingPlanInput.value = isSubscribe ? (option.getAttribute('data-plan-id') || '') : '';
    if (onetimeOption) onetimeOption.classList.toggle('is-selected', !isSubscribe);
    if (subscribeOption) subscribeOption.classList.toggle('is-selected', isSubscribe);

    var available = option.getAttribute('data-available') === 'true';
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var priceCents = isSubscribe
      ? (parseInt(option.getAttribute('data-subscription-price-cents'), 10) || 0)
      : (parseInt(option.getAttribute('data-price-cents'), 10) || 0);
    var currency = section.getAttribute('data-currency') || 'AUD';

    submit.disabled = !available;
    label.textContent = available
      ? submit.getAttribute('data-add-label') + ' · ' + formatProductMoney(priceCents * quantity, currency) + ' →'
      : submit.getAttribute('data-sold-out-label');

    if (price) {
      price.textContent = isSubscribe ? option.getAttribute('data-subscription-price') : option.getAttribute('data-price');
    }

    if (compare) {
      if (isSubscribe && option.getAttribute('data-subscription-compare')) {
        compare.textContent = option.getAttribute('data-subscription-compare');
        compare.hidden = false;
      } else if (!isSubscribe && option.getAttribute('data-compare-price')) {
        compare.textContent = option.getAttribute('data-compare-price');
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }

    if (priceMeta && option.getAttribute('data-price-meta')) {
      priceMeta.textContent = option.getAttribute('data-price-meta');
    }

    if (note) {
      var savePercent = parseInt(option.getAttribute('data-save-percent'), 10) || 0;
      if (!isSubscribe && savePercent > 0) {
        note.textContent = 'You save ' + option.getAttribute('data-save-amount') + ' · just ' + option.getAttribute('data-unit-price') + '/bag';
        note.classList.add('is-saving');
      } else {
        note.textContent = note.getAttribute('data-default-note') || '';
        note.classList.remove('is-saving');
      }
    }
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-ct-product-thumb]');
    if (thumb) {
      var section = thumb.closest('[data-ct-product-section]');
      var image = section ? section.querySelector('[data-ct-product-main-image]') : null;
      if (!image) return;
      image.src = thumb.getAttribute('data-image-src');
      image.srcset = thumb.getAttribute('data-image-srcset');
      image.alt = thumb.getAttribute('data-image-alt') || image.alt;
      section.querySelectorAll('[data-ct-product-thumb]').forEach(function(button) {
        button.classList.toggle('is-active', button === thumb);
      });
      return;
    }

    var minus = event.target.closest('[data-ct-quantity-minus]');
    var plus = event.target.closest('[data-ct-quantity-plus]');
    if (!minus && !plus) return;

    var quantity = event.target.closest('[data-ct-quantity]');
    var input = quantity ? quantity.querySelector('[data-ct-quantity-input]') : null;
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, value + (plus ? 1 : -1));

    var section = input.closest('[data-ct-product-section]');
    if (section) syncProductForm(section);
  });

  document.addEventListener('change', function(event) {
    var jump = event.target.closest('[data-ct-product-jump]');
    if (jump && jump.value) {
      window.location.href = jump.value;
      return;
    }

    var purchaseRadio = event.target.closest('[data-ct-purchase-radio]');
    if (purchaseRadio) {
      var purchaseSection = purchaseRadio.closest('[data-ct-product-section]');
      if (purchaseSection) syncProductForm(purchaseSection);
      return;
    }

    var select = event.target.closest('[data-ct-variant-select]');
    if (!select) return;

    var section = select.closest('[data-ct-product-section]');
    syncProductForm(section);
  });

  document.addEventListener('input', function(event) {
    var quantityInput = event.target.closest('[data-ct-quantity-input]');
    if (!quantityInput) return;

    var section = quantityInput.closest('[data-ct-product-section]');
    if (section) syncProductForm(section);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-ct-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-ct-variant-input]');
    var quantityInput = form.querySelector('[data-ct-quantity-input]');
    var sellingPlanInput = form.querySelector('[data-ct-selling-plan-input]');
    var variantId = variantInput ? variantInput.value : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var sellingPlanId = sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : null;

    if (!variantId || !window.cartDrawer) return;

    event.preventDefault();
    window.cartDrawer.addItem(variantId, quantity, sellingPlanId);
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-ct-product-section]').forEach(syncProductForm);

    if (typeof URLSearchParams === 'undefined') return;
    if (new URLSearchParams(window.location.search).get('subscribe') !== '1') return;

    document.querySelectorAll('[data-ct-purchase-radio="subscribe"]').forEach(function(radio) {
      var section = radio.closest('[data-ct-product-section]');
      var select = section ? section.querySelector('[data-ct-variant-select]') : null;
      var option = select ? select.options[select.selectedIndex] : null;
      if (!option || option.getAttribute('data-has-subscription') !== 'true') return;

      radio.checked = true;
      syncProductForm(section);

      var wrap = section.querySelector('[data-ct-purchase-type-wrap]');
      if (wrap && wrap.scrollIntoView) {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
